const BASE_URL = 'https://www.cian.ru';
const MOSCOW_AND_REGION_ID = -1;
const SAINT_PETERSBURG_AND_REGION_ID = -2;

interface IDominantListingTarget {
  subdomain: string;
  regionId: number | null | undefined;
}

interface IBuildListingButtonUrlParams {
  dominantTarget: IDominantListingTarget;
  listingUrl: string;
  pageHostname: string;
}

export function buildListingButtonUrl(params: IBuildListingButtonUrlParams): string {
  const { dominantTarget, listingUrl, pageHostname } = params;
  const urlWithRegion = addRegionToListingUrl(listingUrl, dominantTarget.regionId);
  const listingButtonUrl = new URL(urlWithRegion, `https://${pageHostname}`);

  listingButtonUrl.hostname = replaceHostnameSubdomain(pageHostname, dominantTarget.subdomain);

  return listingButtonUrl.href;
}

export function addRegionToListingUrl(url: string, regionId: number | null | undefined): string {
  if (regionId === null || regionId === undefined || url === '#') {
    return url;
  }

  const listingUrl = new URL(url, BASE_URL);
  const hasRegionParam = listingUrl.searchParams.has('region');

  if (hasRegionParam) {
    return url;
  }

  listingUrl.searchParams.set('region', String(normalizeRegionId(regionId)));

  return listingUrl.toString();
}

function normalizeRegionId(regionId: number): number {
  if (regionId === 1 || regionId === 4593) {
    return MOSCOW_AND_REGION_ID;
  }

  if (regionId === 2 || regionId === 4588) {
    return SAINT_PETERSBURG_AND_REGION_ID;
  }

  return regionId;
}

function replaceHostnameSubdomain(hostname: string, subdomain: string): string {
  if (isIpHostname(hostname) || hostname === 'localhost') {
    return hostname;
  }

  const hostnameParts = hostname.split('.');

  if (hostnameParts.length < 2) {
    return hostname;
  }

  if (hostnameParts.length === 2) {
    return [subdomain, ...hostnameParts].join('.');
  }

  return [subdomain, ...hostnameParts.slice(1)].join('.');
}

function isIpHostname(hostname: string): boolean {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) || hostname.includes(':');
}
